// extracted by mini-css-extract-plugin
export default {"button":"BoostWithSNButton_button__6CsVt"};